module.exports = __webpack_public_path__ + "img/box1_img_dark.4415e42e.png";